import { render, staticRenderFns } from "./normal.vue?vue&type=template&id=dac4b6cc&scoped=true&"
import script from "./normal.vue?vue&type=script&lang=js&"
export * from "./normal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac4b6cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dac4b6cc')) {
      api.createRecord('dac4b6cc', component.options)
    } else {
      api.reload('dac4b6cc', component.options)
    }
    module.hot.accept("./normal.vue?vue&type=template&id=dac4b6cc&scoped=true&", function () {
      api.rerender('dac4b6cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chatLog/normal.vue"
export default component.exports